module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_8003.f8b2ad53.png";